import * as Icons from "heroicons-react";
import { Accordion, Image, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../../logo.svg";
import { signInUser } from "../../Utility/Auth";
import { resolvePhotoUrl } from "../../Utility/resolvePhotoUrl";
import { useSettingsQuery } from "../../../services/settingsApi";
import { getDisplayLogo } from "../../Utility/packageHelper";
import "./SideBar.css";

const EcomSideBar = () => {
  const auth = signInUser();
  const { aamarId, storeSettings } = auth || {};
  const { data: dbSettings } = useSettingsQuery(aamarId, { skip: !aamarId });
  const activeSettings = dbSettings || storeSettings;
  const storeLogoSrc = getDisplayLogo(auth, dbSettings, logo);
  let active = window.location.pathname;
  return (
    <aside className="sticky-md-top pb-5">
      <Link className="nav-link logo pt-3 pb-5 text-center d-flex justify-content-center align-items-center" to="/">
        <Image
          src={storeLogoSrc}
          fluid
          className="mx-auto d-block"
          style={{ maxHeight: "45px", maxWidth: "100%", objectFit: "contain" }}
          onError={(e) => {
            e.target.src = logo;
          }}
        />
      </Link>
      <nav className="nav flex-column">
        <>
          {/* DASHBOARD */}
          <Link
            className={`nav-link ${active === "/dashboard" && "active"}`}
            to="/dashboard"
          >
            <Icons.AdjustmentsOutline size={22}></Icons.AdjustmentsOutline>{" "}
            Dashboard
          </Link>
          <Link
            className={`nav-link ${active === "/ecom" && "active"}`}
            to="/ecom"
          >
            <Icons.ShoppingCartOutline size={22}></Icons.ShoppingCartOutline>{" "}
            Ecom Sales
          </Link>
          <Link
            className={`nav-link mt-0 ${active === "/profile" && "active"}`}
            to="/profile"
          >
            <Icons.CogOutline size={22} /> Profile Settings
          </Link>
        </>
      </nav>
    </aside>
  );
};

export default EcomSideBar;
